<template>
  <div id="app" class="h-screen relative" @click="closeDropdowns">
    <c-header class="h-1/10" v-if="displayNav"></c-header>

    <router-view
      :class="{'h-full':this.$route.path === '/login', 'h-9/10 pb-4': this.$route.path !== '/login'}"
      :key="key"/>

    <c-loader v-if="isLoaderVisible"/>

    <div class="notification_container" v-if="showQRFound">
      <div class="classen__rounded_full classen__button_active px-5 notification">
        <p>read</p>
      </div>
    </div>

    <c-coockie-banner v-if="!isCookieBannerInvisible" @accepted="checkBanner"/>
  </div>
</template>

<script>
import Header from './components/structure/Header.vue';
import Loader from "./components/Loader";
import EventBus from "./services/EventBus";
import CoockieBanner from "./components/structure/CookieBanner";
import QrReader from "./mixins/qrReader";
import getTranslation from "./mixins/getTranslation";
import selectionService from "./services/ClassenService/modules/selectionService";

export default {
  name: 'App',

  components: {
    'c-header': Header,
    'c-loader': Loader,
    'c-coockie-banner': CoockieBanner,
  },

  mixins: [
    QrReader,
    getTranslation
  ],

  watch: {
    $route() {
      this.key = this.$route.path;
    },
  },

  data() {
    return {
      key: null,
      isLoaderVisible: false,
      isCookieBannerInvisible: true,
    };
  },

  computed: {
    displayNav() {
      let path = this.$route.path;
      return path !== '/login'
    }
  },

  created() {
    EventBus.listen('showLoader', this.showLoader);
    EventBus.listen('hideLoader', this.hideLoader);
    EventBus.listen('loadSiteContent', this.loadContent);

    this.checkBanner();
    // save user sessions
    let userObj = JSON.parse(
      window.localStorage.getItem(process.env.VUE_APP_LOCALSTORAGETAG)
    );

    // fallback for object fit
    window.__store__ = this.$dashboardStore;

    if (this.$route.name === 'Selection') {
        this.$dashboardStore.commit('SET_LANGUAGE', 1);
            selectionService.getSharedSelectionLanguages().then((response) => {
                this.$dashboardStore.commit('SET_LANGUAGES', response.data)
            });
        this.$dashboardStore.dispatch('getTranslations');
        return
    }

    if (userObj === null) {
      this.navigateToLogin();
      return
    }

    if (!this.validateToken(userObj)) {
      this.clearStorage();
      this.navigateToLogin();
      return
    }

    this.$dashboardStore.commit('SET_USER', userObj);
    this.$dashboardStore.commit('SET_LANGUAGE', userObj.languageId);

    this.$dashboardStore.dispatch('setLoggedInAtProperty')
      .catch(() => {
        this.clearStorage();
        this.navigateToLogin();
      });

    this.$dashboardStore.dispatch('setLoggedInAtProperty')
    this.$dashboardStore.dispatch('getTranslations');
    if (!this.$route.params.item_id) {
      this.loadContent();
    }

    this.$dashboardStore.dispatch('getUser', userObj.id)
      .then((res) => {
        let newUserData = res.data;
        newUserData.access_token = userObj.access_token;
        if (userObj.needsToChangePassword) {
          this.$dashboardStore.dispatch('clearAuthUser');
          EventBus.fire('signed-out-user');
          this.$router.push({path: '/login'})
        } else {
          this.$dashboardStore.commit('SET_USER', newUserData);
          this.$dashboardStore.commit('SET_LANGUAGE', newUserData.languageId);
        }
      })
  },

  destroyed() {
    EventBus.destroy('showLoader', this.showLoader);
    EventBus.destroy('hideLoader', this.hideLoader);
    EventBus.destroy('loadSiteContent', this.loadContent);
  },

  methods: {
    loadContent() {
      this.$dashboardStore.dispatch('getAllKeysWithTranslations');
      this.$dashboardStore.dispatch('getLanguages');
      this.$dashboardStore.dispatch('getSelections');
      this.$dashboardStore.dispatch('getUsers');
      this.$dashboardStore.dispatch('getRegions');
    },

    checkBanner() {
      this.isCookieBannerInvisible = localStorage.getItem('cookieBanner') === 'Accepted';
    },

    showLoader() {
      this.isLoaderVisible = true;
    },

    hideLoader() {
      this.isLoaderVisible = false;
    },

    validateToken({expires_at}) {
      const expireDate = new Date(expires_at);
      return new Date() < expireDate;
    },

    navigateToLogin() {
      if (this.$router.currentRoute.path !== '/login') {
        this.$router.push({path: 'login'});
      }
    },

    clearStorage() {
      this.$dashboardStore.dispatch('clearAuthUser');
      this.$dashboardStore.dispatch('clearUsers');
    },

    closeDropdowns() {
      this.$emit('close-selection')
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.notification_container {
  height: 42px;
  position: absolute;
  bottom: 50px;
  width: 100%;
  text-align: center;
}

.notification {
  width: fit-content;
  margin: 0 auto;
}
</style>
